module.exports = __webpack_public_path__ + "img/Partner-Badges-2023_Partner.a0b8adbb.png";